import * as isoCountries from "i18n-iso-countries";
import csLocale from "i18n-iso-countries/langs/cs.json";
import enLocale from "i18n-iso-countries/langs/en.json";
import { i18n } from "@lingui/core";

isoCountries.registerLocale(csLocale);
isoCountries.registerLocale(enLocale);

export const getNameFromCountryCode = (countryCode?: string) => {
  if (!countryCode) return;
  return isoCountries.getName(countryCode, i18n.locale);
};
